<h1 class="d-none">Kachiing Polling</h1>
<div class="poll">
  <div class="container">
    <div class="d-flex justify-content-end">
      <button class="my-button-3 mb-2" (click)="openPollModal(pollForm)"><i class="fa-solid fa-poll"></i> New
        Poll</button>
    </div>

    <ng-container *ngIf="polls.isLoading">
      <div class="card mb-3 skeleton-card" *ngFor="let _ of [1, 2, 3]">
        <div class="card-body d-flex py-0" style="gap: 1em">
          <div class="flex-grow-1 border-right py-3 px-2">
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!polls.isLoading">
      <div *ngIf="polls?.data?.length < 1">
        <div class="alert alert-secondary text-center" role="alert"><i class="fa-regular fa-comment-alt"></i> There are
          no polling at this time</div>
      </div>
      <div class="row">
        <div class="col-md-4" *ngFor="let row of polls?.data; let index = index">
          <div class="poll__card">
            <img loading="lazy" src="../../../../assets/images/new/forum.jpg" alt="" />
            <div class="poll__card--header">
              <div class="name">{{ row.name }}</div>
              <div class="time">{{ row.remainingTime }} Left</div>
            </div>
            <div class="poll__card--body">
              <ng-container *ngFor="let child of row.poll_details; let i = index">
                <div class="mb-1" *ngIf="(i < 4 && !row.showMore) || row.showMore">
                  <div class="d-flex" style="gap: 0.5em">
                    <div class="flex-grow-1 progress"
                      style="height: 2rem; background-color: rgba(var(--black-rgb), var(--black-rgb), var(--black-rgb), 0.25)">
                      <div class="progress-bar text-left" role="progressbar" style="overflow: unset !important"
                        [style.width]="child.progress"
                        [style.backgroundColor]="pollsColor[i] != null ? pollsColor[i] : 'grey'"
                        aria-valuenow="{{ child.progress?.replace('%', '') }}" aria-valuemin="0" aria-valuemax="100">
                        <span class="px-3 fw-bolder" style="font-size: 16px"> {{ child.name }} ({{
                          child.poll_interactions.length }}) </span>
                      </div>
                    </div>
                    <label class="progress-checkbox" *ngIf="isLogin == 0" (click)="checkPoll(row, child)">
                      <span class="checkmark mr-0"></span>
                    </label>
                    <label class="progress-checkbox" *ngIf="isLogin == 1">
                      <input type="checkbox" [checked]="hasCheckedPoll(child.poll_interactions)"
                        (change)="checkPoll(row, child)" />
                      <span class="checkmark mr-0"></span>
                    </label>
                  </div>
                </div>
                <button class="btn btn-light text-center w-100"
                  *ngIf="i == 3 && !row.showMore && row.poll_details.length - 4 != 0" (click)="row.showMore = true">
                  Show {{ row.poll_details.length - 4 }} more
                  <i class="fa-solid fa-chevron-down"></i>
                </button>
                <button class="btn btn-light text-center w-100" *ngIf="row.showMore && i == row.poll_details.length - 1"
                  (click)="row.showMore = false">See less <i class="fa-solid fa-chevron-up"></i></button>
              </ng-container>
            </div>

            <!-- <button class="btn btn-light w-100" *ngIf="i < 5 && !row.showMore || row.showMore"
                        type="button" (click)="openNewOptionModal(newOptionPollingAdd, row)">
                        <i class="fa-solid fa-plus"></i>
                    </button> -->
            <div class="poll__card--footer">
              <div class="icons">
                <span (click)="likePoll(row.id, row)">
                  {{ row.poll_likes.length }}
                  <i class="{{ hasCheckedPoll(row.poll_likes) ? 'fa-solid' : 'fa-regular' }} fa-heart"></i>
                </span>
                <span (click)="copyLink('poll', row)">
                  <i class="fa-solid fa-link"></i>
                </span>
              </div>
              <div *ngIf="isLogin == 1" class="list">
                <span class="list__bars" (click)="handleShowOptionPoll(index)">
                  <i class="fa-solid fa-ellipsis-v"></i>
                </span>
                <div class="list__menu" (mouseleave)="handleShowOptionPoll(index)" [class.active]="row.showOption">
                  <!-- <a class="text-nowrap" *ngIf="isModerator()" href="#"
                        (click)="editForumMessage($event, i)">
                        <i class="fa-solid fa-pen"></i> Edit
                    </a> -->
                  <div class="list__menu--item" (click)="deletePoll($event, row.id)"><i class="fa-solid fa-trash"></i>
                    Delete</div>
                  <div class="list__menu--item" (click)="openNewOptionModal($event, newOptionPollingAdd, row)"><i
                      class="fa-solid fa-plus"></i> Option</div>
                  <!-- <a class="text-nowrap" href="#"
            (click)="openDetailPost($event, detailPost, item)">
            <i class="fa-solid fa-eye"></i> Detail
        </a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #newOptionPollingAdd let-modal>
  <div id="new_polling_option_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-body">
      <h5 class="text-center">New Polling Option {{ newPolling.title }}</h5>
      <div class="form-group">
        <label for="">Title</label>
        <input type="text" [(ngModel)]="newPolling.option" class="form-control" />
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-danger mr-2" [disabled]="newPolling?.hasSubmit" (click)="modalService.dismissAll()"><i
          class="fa-solid fa-times"></i> Cancel</button>
      <button class="btn btn-primary" (click)="newPollingStore()" [disabled]="newPolling?.hasSubmit"><i
          class="fa-solid fa-paper-plane"></i> Submit</button>
    </div>
  </div>
</ng-template>
<ng-template #pollForm let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Create New Poll</h2>
    <form (submit)="storePoll()">
      <div class="form-group">
        <label for="" class="mb-0">Title</label>
        <input ngRequr type="text" [(ngModel)]="poll.name" [ngModelOptions]="{ standalone: true }"
          class="form-control" />
      </div>
      <div class="row">
        <div class="form-group col-sm-6">
          <label for="" class="mb-0">Start Date</label>
          <input ngRequr type="date" [(ngModel)]="poll.startDate" [ngModelOptions]="{ standalone: true }"
            class="form-control" />
        </div>
        <div class="form-group col-sm-6">
          <label for="" class="mb-0">End Date</label>
          <input ngRequr type="date" [(ngModel)]="poll.endDate" [min]="poll.startDate"
            [ngModelOptions]="{ standalone: true }" class="form-control" />
        </div>
      </div>
      <button class="my-button-3 secondary mb-3" type="button" (click)="addPollsChild()"><i
          class="fa-solid fa-plus"></i> Add Poll</button>
      <div class="form-group" *ngFor="let row of poll.polls; let i = index">
        <label for="">Polling {{ i + 1 }}</label>
        <div class="d-flex">
          <input ngRequr type="text" [(ngModel)]="row.name" placeholder="Title for Polling {{ i + 1 }}"
            [ngModelOptions]="{ standalone: true }" class="form-control" />
          <button type="button" class="btn btn-danger btn-sm ml-2" (click)="removePollsChild(i)">
            <i class="fa-solid fa-trash"></i>
          </button>
        </div>
      </div>
      <div class="modal-footer px-0 pb-0">
        <button type="button" class="my-button-3 error" [disabled]="forum?.hasSubmit"
          (click)="modalService.dismissAll()"><i class="fa-solid fa-times"></i> Cancel</button>
        <button class="my-button-3" type="submit" [disabled]="forum?.hasSubmit"><i class="fa-solid fa-paper-plane"></i>
          Submit</button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #pollDetailModal let-modal>
  <div class="modal-header d-flex justify-content-between">
    <div class="d-flex">
      <h3 class="my-auto">POLL</h3>
    </div>
    <span class="my-auto text-purple pointer" style="font-size: 20px" (click)="modalService.dismissAll()">
      <i class="fa-solid fa-times"></i>
    </span>
  </div>
  <div class="modal-body">
    <div class="card mb-3" *ngIf="pollDetail.isActive">
      <div class="card-header d-flex justify-content-between">
        <div class="d-flex">
          <span class="mr-1 pointer" (click)="copyLink('poll', pollDetail)">
            <i class="fa-solid fa-link"></i>
          </span>
          <h6 class="my-auto">{{ pollDetail.name }}</h6>
        </div>
        <div>
          <span class="mr-1 text-nowrap" style="color: salmon" (click)="likePoll(pollDetail.id, pollDetail)">
            {{ pollDetail.poll_likes.length }}
            <i class="{{ hasCheckedPoll(pollDetail.poll_likes) ? 'fa-solid' : 'fa-regular' }} fa-heart"></i>
          </span>
          <div class="forum-product-child">
            <div *ngIf="isLogin == 1">
              <span class="forum-product-toggle" style="top: -26px" (click)="pollDetail.showOption = true">
                <i class="fa-solid fa-ellipsis-v"></i>
              </span>
              <div (mouseleave)="pollDetail.showOption = false" class="forum-product-dropdown"
                [class.d-none]="!pollDetail.showOption">
                <!-- <a class="text-nowrap" *ngIf="isModerator()" href="#"
                                (click)="editForumMessage($event, i)">
                                <i class="fa-solid fa-pen"></i> Edit
                            </a> -->
                <a class="text-nowrap" href="#" (click)="deletePoll($event, pollDetail.id)"> <i
                    class="fa-solid fa-trash"></i> Delete </a>
                <a class="text-nowrap" href="#" (click)="openNewOptionModal($event, newOptionPollingAdd, pollDetail)">
                  <i class="fa-solid fa-plus"></i> Option </a>
                <!-- <a class="text-nowrap" href="#"
                    (click)="openDetailPost($event, detailPost, item)">
                    <i class="fa-solid fa-eye"></i> Detail
                </a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="d-flex justify-content-end mb-2">
          <span class="badge badge-primary">{{ pollDetail.remainingTime }} Left</span>
        </div>
        <ng-container *ngFor="let child of pollDetail.poll_details; let i = index">
          <div class="mb-1" *ngIf="(i < 4 && !pollDetail.showMore) || pollDetail.showMore">
            <div class="d-flex" style="gap: 0.5em">
              <div class="flex-grow-1 progress" style="height: 30px; background-color: #b9b9b9">
                <div class="progress-bar text-left" role="progressbar" style="overflow: unset !important"
                  [style.width]="child.progress"
                  [style.backgroundColor]="pollsColor[i] != null ? pollsColor[i] : 'grey'"
                  aria-valuenow="{{ child.progress?.replace('%', '') }}" aria-valuemin="0" aria-valuemax="100">
                  <span class="px-3 fw-bolder" style="font-size: 16px"> {{ child.name }} ({{
                    child.poll_interactions.length }}) </span>
                </div>
              </div>
              <label class="progress-checkbox" *ngIf="isLogin == 0" (click)="checkPoll(pollDetail, child)">
                <span class="checkmark mr-0"></span>
              </label>
              <label class="progress-checkbox" *ngIf="isLogin == 1">
                <input type="checkbox" [checked]="hasCheckedPoll(child.poll_interactions)"
                  (change)="checkPoll(pollDetail, child)" />
                <span class="checkmark mr-0"></span>
              </label>
            </div>
          </div>
          <button class="btn btn-light text-center w-100" *ngIf="i == 3 && !pollDetail.showMore"
            (click)="pollDetail.showMore = true">
            Show {{ pollDetail.poll_details.length - 4 }} more
            <i class="fa-solid fa-chevron-down"></i>
          </button>
          <button class="btn btn-light text-center w-100"
            *ngIf="pollDetail.showMore && i == pollDetail.poll_details.length - 1"
            (click)="pollDetail.showMore = false">See less <i class="fa-solid fa-chevron-up"></i></button>
        </ng-container>
        <!-- <button class="btn btn-light w-100" *ngIf="i < 5 && !pollDetail.showMore || pollDetail.showMore"
                type="button" (click)="openNewOptionModal(newOptionPollingAdd, row)">
                <i class="fa-solid fa-plus"></i>
            </button> -->
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm btn-secondary" (click)="modalService.dismissAll()"><i
        class="fa-solid fa-times"></i> Close</button>
  </div>
</ng-template>